import script from "./BankVisitClientTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BankVisitClientTable.vue?vue&type=script&setup=true&lang=js"

import "./BankVisitClientTable.vue?vue&type=style&index=0&id=0a4eeb6a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4eeb6a"]])

export default __exports__